import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-play",
  imports: [],
  templateUrl: "./icon-play.component.html",
  styleUrl: "./icon-play.component.scss",
})
export class IconPlayComponent {
  @Input() color = "#000";
  @Input() customClass: string;
}
